module.exports = __webpack_public_path__ + "static/intro-f955feb90d4a5f3880ff8019b70f7d15.jpg";